import { render } from "./UserModal1.vue?vue&type=template&id=3c7ca404"
import script from "./UserModal1.vue?vue&type=script&lang=ts"
export * from "./UserModal1.vue?vue&type=script&lang=ts"

import "./UserModal1.vue?vue&type=style&index=0&id=3c7ca404&lang=css"
script.render = render

export default script